import React from 'react';

import '@eika/card-style/src/WarningCard.scss';
import { RichIconTypes } from '@eika/rich-icon';

import Card, { CardProps } from './Card';

const WarningCard: React.FC<CardProps> = ({ children, title, icon, isModal, ...rest }) => (
    <Card {...rest} title={title} isModal={isModal} icon={icon ?? RichIconTypes.HAAND_HEIHEI}>
        {children}
    </Card>
);

export default WarningCard;
